import React from "react";
import * as m from "../lib/model";

// Seller rollover is COMMON equity / a profits interest: no pref, no return of capital, and it ranks
// behind the LP liquidation preference and the GP promote. Shown on every returns / schedule surface.
export function RollNote({ M, testid = "roll-own-note", style }) {
  const ex = m.exitReturns(M);
  if (!(ex.rollOwnPct > 0.01)) return null;
  return (
    <div className="ir-fine" style={style} data-testid={testid}>
      {ex.rollIsRecap
        ? <>Legacy investors roll <b>{m.fmt$(ex.rollEquity)}</b> — the equity value they do <i>not</i> cash out — which is <b>{m.fmtPct(ex.rollOwnPct)}</b> of the {m.fmt$(ex.rollPriceBase)} of total equity in the deal.</>
        : <>Seller rolls <b>{m.fmt$(ex.rollEquity)}</b>, which is <b>{m.fmtPct(ex.rollOwnPct)}</b> of the {m.fmt$(ex.rollPriceBase)} of total equity in the deal (debt and the seller note fund the rest of the price and own nothing).</>}
      {" "}That stake is <b>common / a profits interest — subordinated by design</b>: senior debt → LP preferred (accrued pref, return of capital, then a <b>{m.fmtX(ex.liqPrefX)} {ex.liqPrefPart ? "participating" : "non-participating"} liquidation preference</b> of {m.fmt$(ex.liqPref)}{ex.liqPrefDue < ex.liqPref - 0.5 ? `, ${m.fmt$(ex.liqPrefDue)} still due at exit after interim cash` : ""}) → GP promote → rolled common. It sees {m.fmt$(ex.rollExit)} at exit — a <b>{m.fmtX(ex.rollMoic)} MOIC</b> on the {m.fmt$(ex.rollEquity)} rolled — never more than {m.fmtPct(ex.rollOwnPct)} of the {m.fmt$(ex.baseEquityAtExit)} exit equity, and takes nothing from interim distributions.
    </div>
  );
}

export function RollRow({ M, years, testid = "roll-own-row" }) {
  const ex = m.exitReturns(M);
  if (!(ex.rollOwnPct > 0.01) || !years || !years.length) return null;
  const last = years[years.length - 1];
  return (
    <>
      <tr data-testid={testid}>
        <td>Seller rolled common — {m.fmtPct(ex.rollOwnPct)} of equity, last in the stack (behind LP pref &amp; promote)</td>
        {years.map((y) => <td className="num exp" key={y}>{y === last ? m.fmt$(-ex.rollExit) : "—"}</td>)}
        <td className="num exp">{m.fmt$(-ex.rollExit)}</td>
      </tr>
      <tr data-testid={`${testid}-moic`}>
        <td>Seller MOIC on rolled equity — {m.fmt$(ex.rollExit)} ÷ {m.fmt$(ex.rollEquity)} rolled</td>
        {years.map((y) => <td className="num" key={y}>{y === last ? m.fmtX(ex.rollMoic) : "—"}</td>)}
        <td className="num">{m.fmtX(ex.rollMoic)}</td>
      </tr>
    </>
  );
}
